import classNames from 'classnames'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'
import { ReactSVG } from 'react-svg'
import { useMediaQuery } from 'usehooks-ts'

import { useLogout } from '@entities/User'

import { useErrorInfoModal } from '@features/modal'

import { personalRoutes } from '@widgets/personal/nav/model/personalNavigation'

import Item from './PersonalNavItem'

import styles from './styles.module.scss'



export default function PersonalNav ({
  isBottomNavVariant = false,
}: {
  isBottomNavVariant?: boolean;
}) {
  const [ logout ] = useLogout()
  const isTablet = useMediaQuery('(max-width: 1279.9px)')
  const location = useLocation()
  const activePath = location.pathname.split('/').pop()
  const [ isOpen, setIsOpen ] = useState(false)
  const { t: tn } = useTranslation('personal')
  const { t: tc } = useTranslation('auth')
  const { t: te } = useTranslation('errors')
  const { openErrorInfoModal } = useErrorInfoModal()

  const logOutHandler = async () => {
    try {
      await logout()
      window.location.href = '/'
    }
    catch (error) {
      console.error('Fetch logout error', error)
      openErrorInfoModal({
        description: te('logout_error'),
      })
    }
  }

  const handleToggleList = () => setIsOpen((p) => !p)

  if (isBottomNavVariant && isTablet) {
    return (
      <div className={classNames(styles.root, styles['root--bottom'])}>
        <div className={styles.root__list}>
          {personalRoutes.map(({ path }, i) => (
            <Item
              onClick={handleToggleList}
              activePath={activePath}
              key={`${path}-${i}`}
              path={path}
              isTablet={false}
            />
          ))}
          <a onClick={logOutHandler} className={classNames(styles.item)}>
            <ReactSVG src={'/icons/logout.svg'} />
            {tc('logout.button')}
          </a>
        </div>
      </div>
    )
  }
  else if (isBottomNavVariant) {
    return null
  }
  else if (isTablet && activePath === 'personal') {
    return null
  }

  return (
    <div className={styles.root}>
      <>
        {isTablet && !isOpen ? (
          <div onClick={handleToggleList} className={styles.root__select}>
            <p>{tn(`nav.${activePath}`)}</p>
            <ReactSVG
              className={styles.root__arrow}
              src="/icons/arrow.svg"
              wrapper="span"
            />
          </div>
        ) : null}
        {isOpen || !isTablet ? (
          <div className={styles.root__list}>
            {personalRoutes.map(({ path }, i) => (
              <Item
                onClick={handleToggleList}
                activePath={activePath}
                key={`${path}-${i}`}
                path={path}
                isTablet={isTablet}
              />
            ))}
            <a onClick={logOutHandler} className={classNames(styles.item)}>
              <ReactSVG src={'/icons/logout.svg'} />
              {tc('logout.button')}
            </a>
          </div>
        ) : null}
      </>
    </div>
  )
}
